import store from './store'
import { GetOrgsByCode } from './api/auth'
import { getDevOrgCode, resolveStoreOrg } from '@/utils/app'

// The GIMMATEK theme is imported statically in main.js; DashboardConfig.theme is ignored (CNCY-10759)
export const setOrgConfig = async () => {
  const env = process.env.NODE_ENV

  console.log('NODE_ENV', env)

  // 僅開發環境允許用 VUE_APP_DEV_ORG_CODE 覆寫，
  // 避免誤設時讓正式環境所有租戶都套到同一個集團
  const hostOrg = resolveStoreOrg({ overrideCode: getDevOrgCode() })

  // 入口或找不到組織時不載入集團設定（登入頁自行處理）
  if (hostOrg.kind === 'org') {
    const res = await GetOrgsByCode({
      code: hostOrg.code,
    })
    store.commit('org/SET_ORG', res)
    store.dispatch('org/getUserInfoSetting', res.id)

    // -- 管考模式啟動時登入導轉頁面
    if (res.DashboardConfig?.enableRedirect) location = res.DashboardConfig.redirectURL
  }
}
